import axios from './api.request'



export const getList = (info) => {
  return axios.request({
      url: '/creatorcamp/index/index',
      data: info,
      method: 'post'
  })
}

export const getStudyVideoList = (info) => {
  return axios.request({
      url: '/creatorcamp/index/studyVideo',
      data: info,
      method: 'post'
  })
}


export const getActivityList = (info) => {
  return axios.request({
      url: '/creatorcamp/index/activity',
      data: info,
      method: 'post'
  })
}

export const applyConfig = (info) => {
  return axios.request({
      url: '/creatorcamp/index/applyConfig',
      data: info,
      method: 'post'
  })
}

export const apply = (info) => {
  return axios.request({
      url: '/creatorcamp/apply/apply',
      data: info,
      method: 'post'
  })
}


export const activityDetail = (info) => {
  return axios.request({
      url: '/creatorcamp/index/activityDetail',
      data: info,
      method: 'post'
  })
}


export const agreement = (info) => {
  return axios.request({
      url: '/creatorcamp/index/agreement',
      data: info,
      method: 'post'
  })
}

export const getErrorCode = (lang) => {
  return axios.request({
      url: process.env.VUE_APP_BASEURL + '/i18n/static_page?page=/i18n/creatorcamp/' + lang + '.json',
      param: lang,
      method: 'get'
  })
}

